'use client';
import {
  useFormContext,
  useController,
  UseControllerProps
} from 'react-hook-form';
import { BlocksCheckboxChangeEvent } from '@blocks-web-components/events/blocks-checkbox-change';

export const useCheckboxController = (props: UseControllerProps) => {
  const { control, setValue } = useFormContext();
  const { field, fieldState, ...rest } = useController({ control, ...props });
  const isError = !!fieldState.error;
  const errorNote = fieldState.error?.message;
  const onBlCheckboxChange = (e: BlocksCheckboxChangeEvent) =>
    setValue(props.name, e.detail.checked);
  return {
    field,
    fieldState,
    booleanCheckboxField: {
      ...field,
      checked: field.value,
      onBlCheckboxChange
    },
    checkboxFieldset: { errorNote, isError },
    ...rest
  };
};
